import { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";

import { ServiceType } from "../../utils/booking";
const Staff = ({
  dpc,
  dpcs,
  onChange,
}: {
  dpc: ServiceType | null;
  dpcs: ServiceType[];
  // eslint-disable-next-line no-unused-vars
  onChange: (dpc: ServiceType | null) => void;
}) => {
  const [staff, setStaff] = useState<ServiceType | null>();
  const [showStaff, setShowStaff] = useState(false);

  useEffect(() => {
    setStaff(dpc);
  }, [dpc]);

  const handleSelectDpc = (value: ServiceType | null) => {
    onChange(value);
    setStaff(value);
    setShowStaff(false);
  };

  const defaultProps = {
    options: dpcs,
    getOptionLabel: (option: ServiceType) => option.staff_name,
  };

  const handleShowStaffList = () => {
    setShowStaff(!showStaff);
  };

  return (
    <Box>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ gap: 1 }}
      >
        <Typography>
          Your appointment will be booked with{" "}
          {staff?.staff_name ? `${staff.staff_name}` : "any available staff"}
        </Typography>
        {dpcs && dpcs.length > 1 ? (
          <Button
            onClick={handleShowStaffList}
            sx={{
              textTransform: "none",
              fontFamily: "Arial",
              fontSize: "18px",
            }}
          >
            Change
          </Button>
        ) : null}
      </Stack>
      {showStaff && (
        <Autocomplete
          {...defaultProps}
          key={Date.now()}
          size="small"
          onChange={(_: any, newValue: ServiceType | null) => {
            handleSelectDpc(newValue);
          }}
          defaultValue={
            dpcs.find((x: ServiceType) => x.staff_id === staff?.staff_id)
              ? staff
              : null
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose a Staff"
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-password", // disable autocomplete and autofill
                type: "search",
              }}
            />
          )}
        />
      )}
    </Box>
  );
};

export default Staff;
